const BCheckbox = ({ id, value, label, ...props }) => {
  return (
    <div className="inline-flex items-center gap-1">
      <label className="relative flex items-center cursor-pointer" htmlFor="html">
        <input
          {...props}
          type="checkbox"
          value={value}
          className="size-4 cursor-pointer  rounded-full  transition-all"
          id={id}
        />
      </label>
      <label htmlFor={id} className="leading-none text-sm font-normal text-slate-700 ">
        {label}
      </label>
    </div>
  );
};

export default BCheckbox;
